// extracted by mini-css-extract-plugin
export default {"wrapper":"app-module__wrapper--M7ysV","content":"app-module__content--WbcQf"};